/* For Creators application form.
   Sends the answers to a Google Apps Script web app, which appends a row to
   the program's Google Sheet (see tools/creators/). */
(() => {
  const forms = document.querySelectorAll('[data-cr-form]');
  if (!forms.length) return;

  const loadedAt = Date.now();

  forms.forEach((form) => {
    const root = form.closest('[data-cr-form-root]');
    const submit = form.querySelector('[data-cr-submit]');
    const status = form.querySelector('[data-cr-status]');
    const done = root.querySelector('[data-cr-done]');
    const chips = form.querySelector('[data-cr-chips]');
    const submitLabel = submit.textContent;

    const showStatus = (message, isError) => {
      status.hidden = !message;
      status.classList.toggle('cr-form__status--error', Boolean(isError));
      status.textContent = message || '';
    };

    const showFailure = () => {
      const email = form.dataset.contactEmail;
      showStatus(form.dataset.errorMessage, true);
      if (email) {
        const link = document.createElement('a');
        link.href = `mailto:${email}`;
        link.textContent = email;
        status.append(' ', link, '.');
      }
    };

    const chipsChosen = () => !chips || chips.querySelector('input:checked');

    // Profile fields take either a @handle or a link. Empty optional fields pass.
    const profilePattern = /^(@?[A-Za-z0-9._-]{2,40}|(https?:\/\/)?([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(\/\S*)?)$/;
    const checkProfile = (field) => {
      const value = field.value.trim();
      field.setCustomValidity(!value || profilePattern.test(value) ? '' : 'Enter a @handle or a profile link.');
    };
    form.querySelectorAll('[data-cr-profile]').forEach((field) => {
      checkProfile(field);
      field.addEventListener('input', () => checkProfile(field));
    });

    // Clear the error look as soon as a field is fixed.
    form.addEventListener('input', (event) => {
      const field = event.target;
      if (field.matches('[aria-invalid="true"]') && field.checkValidity()) {
        field.removeAttribute('aria-invalid');
      }
      if (chips && chips.contains(field) && chipsChosen()) {
        chips.removeAttribute('aria-invalid');
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit.disabled) return;

      let firstInvalid = null;
      form.querySelectorAll('input, select, textarea').forEach((field) => {
        if (field.name === 'website' || field.name === 'content_types') return;
        if (!field.checkValidity()) {
          field.setAttribute('aria-invalid', 'true');
          firstInvalid = firstInvalid || field;
        }
      });
      if (!chipsChosen()) {
        chips.setAttribute('aria-invalid', 'true');
        firstInvalid = firstInvalid || chips.querySelector('input');
      }
      if (firstInvalid) {
        showStatus(form.dataset.requiredMessage, true);
        firstInvalid.focus();
        return;
      }

      const endpoint = form.dataset.endpoint;
      if (!endpoint) {
        showFailure();
        return;
      }

      const data = new FormData(form);
      const payload = {
        first_name: data.get('first_name'),
        last_name: data.get('last_name'),
        email: data.get('email'),
        product: data.get('product'),
        platform: data.get('platform'),
        profile_url: data.get('profile_url'),
        followers: data.get('followers'),
        content_types: data.getAll('content_types').join(', '),
        secondary_url: data.get('secondary_url'),
        audience: data.get('audience'),
        age_us: data.get('age_us') === 'yes',
        terms: data.get('terms') === 'yes',
        marketing: data.get('marketing') === 'yes',
        website: data.get('website'),
        elapsed_ms: Date.now() - loadedAt,
        page: window.location.href.split('#')[0],
      };

      submit.disabled = true;
      submit.textContent = submit.dataset.sendingLabel || submitLabel;
      showStatus('');

      try {
        // A plain-text body keeps this a "simple" request, so the browser
        // does not send a CORS preflight that Apps Script cannot answer.
        const response = await fetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (!result.ok) throw new Error(result.error || 'Not saved');

        form.hidden = true;
        done.hidden = false;
        done.focus();
      } catch (error) {
        showFailure();
        submit.disabled = false;
        submit.textContent = submitLabel;
      }
    });
  });
})();
